export const ONBOARDING_ROVO_VIDEO_PLAYER_STATE_KEYS = {
	ROVO_VIDEO_PLAYER_SEEN: 'onboarding-rovo-video-player:rovoVideoPlayerSeen',
} as const;

export const RovoVideoPlayerStateOnboardingKeys = [
	...Object.values(ONBOARDING_ROVO_VIDEO_PLAYER_STATE_KEYS),
] as const;
